import { iframePush } from 'core/iframe';

export function NewsRedirect(props) {
    iframePush('https://blog.openstartups.net/', '/home')();
    return null;
}
export default NewsRedirect;
